import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import {
  fetchFieldExecByIdThunk,
  generateAgreementThunk,
} from "../redux/features/mandateSlice";
import { formatDebitDate } from "../utils/utilsFunction";

const SignAggrement = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const [fieldExecutiveData, setFieldExecutiveData] = useState({});
  const [loading, setLoading] = useState(false);

  const executiveFormik = useFormik({
    initialValues: {
      agreement: false,
    },
    validationSchema: Yup.object().shape({
      agreement: Yup.boolean()
        .required("You must accept the agreement")
        .oneOf([true], "You must accept the agreement"),
    }),

    onSubmit: async () => {
      setLoading(true);
      try {
        const agreementData = {
          id: fieldExecutiveData._id,
          name: fieldExecutiveData.name,
          email: fieldExecutiveData.email,
          phone: fieldExecutiveData.phone,
          dob: fieldExecutiveData.dob,
          address: fieldExecutiveData.address.address_line,
          city: fieldExecutiveData.address.city,
          state: fieldExecutiveData.address.state,
          pincode: fieldExecutiveData.address.pincode,
          aadhaar_no: fieldExecutiveData.aadhaar_no,
          profile_photo: fieldExecutiveData.profilePhoto,
          date: formatDebitDate(Date.now()),
          accountName:
            fieldExecutiveData.mandate_id.bankDetails.accountHolderName,
          accountNo: fieldExecutiveData.mandate_id.bankDetails.accountNumber,
          ifscCode: fieldExecutiveData.mandate_id.bankDetails.ifscCode,
          signName: fieldExecutiveData.name,
        };

        const agreementResponse = await dispatch(
          generateAgreementThunk(agreementData)
        );

        if (agreementResponse.meta.requestStatus === "fulfilled") {
          toast.success(
            "Registration successful! Please review the agreement.", {
              duration: 6000, 
            }
          );
          navigate("/");
        } else {
          console.error("Agreement generation failed:", agreementResponse);
          toast.error("Failed to Signed agreement. Please try again.");
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Failed to Signed agreement. Please try again.");
      }
    },
  });

  useEffect(() => {
    dispatch(fetchFieldExecByIdThunk(params.id)).then((data) => {
      if (data.meta.requestStatus === "fulfilled") {
        setFieldExecutiveData(data.payload.data);
      } else {
        toast.error(data.payload);
        navigate("/");
      }
    });
  }, [dispatch, params, navigate]);

  useEffect(() => {
    if (!fieldExecutiveData.signedAgreement) return; // Exit early if the agreement is signed

    toast.success("Agreement Already Signed");
    navigate("/"); // Navigate after 1 second
  }, [fieldExecutiveData.signedAgreement, navigate]);

  return (
    <div
      className="w-full min-h-screen flex items-center justify-center relative overflow-y-auto"
      style={{
        background: `linear-gradient(135deg, #67221A 50%, #FFFFFF 50%)`,
      }}
    >
      <div className="w-full max-w-4xl p-4 md:p-6 lg:p-8 bg-white rounded-lg shadow-lg z-10">
        <form onSubmit={executiveFormik.handleSubmit}>
          <div>
            <h2 className="text-lg font-semibold mb-4 text-black">Agreement</h2>

            {/* Agreement Container */}
            <div className="relative">
              {fieldExecutiveData.agreement_url && (
                <div className="relative">
                  <iframe
                    title="aggrement"
                    src={`https://docs.google.com/viewer?url=${encodeURIComponent(
                      fieldExecutiveData.agreement_url
                    )}&embedded=true`}
                    className="w-full h-[500px] border rounded-lg mt-4"
                    style={
                      {
                        //   pointerEvents: "none",
                      }
                    }
                  />
                  {/* Removed the digital signature floating text */}
                  {/* Name Overlay - positioned behind "Digitally Signed by" */}
                  {executiveFormik.values.agreement && (
                    <div
                      className="absolute text-black"
                      style={{
                        bottom: "80px",
                        right: "120px",
                        zIndex: 50,
                        padding: "2px 4px",
                        fontSize: "14px",
                        fontWeight: "500",
                        fontFamily: "Arial, sans-serif",
                        lineHeight: "1.2",
                        textAlign: "center",
                      }}
                    >
                      {/* {executiveFormik.values.name} */}
                    </div>
                  )}
                </div>
              )}
            </div>

            <label className="flex items-center space-x-2 text-black mt-4">
              <input
                name="agreement"
                type="checkbox"
                checked={executiveFormik.values.agreement}
                onChange={(e) => {
                  executiveFormik.handleChange(e);
                  // setShowNameOnAgreement(e.target.checked);
                }}
                onBlur={executiveFormik.handleBlur}
                className="h-4 w-4"
              />
              <span className="text-black">
                I accept the terms and conditions
              </span>
            </label>

            {executiveFormik.touched.agreement &&
              executiveFormik.errors.agreement && (
                <div className="text-red-500 text-sm">
                  {executiveFormik.errors.agreement}
                </div>
              )}
          </div>

          <div className="flex justify-end mt-6">
            <button
              type="submit"
              disabled={loading || !executiveFormik.values.agreement}
              className={`bg-[#67221A] text-white rounded-3xl px-4 py-2 font-semibold ${
                loading || !executiveFormik.values.agreement
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:bg-[#012647]"
              }`}
            >
              {loading ? "Processing..." : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignAggrement;
